// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ps__thumb-y {\n    background-color: #455a64 !important;\n}\n@media (min-width: 992px) {\nbody.pt-scroll {\n        padding-top: 128px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
